import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMedia = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M3.929 3.929c1.256-1.256 3.13-1.731 5.53-1.731h5.582c2.4 0 4.274.475 5.53 1.731 1.256 1.256 1.731 3.13 1.731 5.53v5.582c0 2.4-.475 4.274-1.73 5.53-1.257 1.256-3.132 1.731-5.531 1.731H9.459c-2.4 0-4.274-.475-5.53-1.731-1.256-1.256-1.731-3.13-1.731-5.53V9.459c0-2.4.475-4.274 1.731-5.53Zm1.06 1.06c-.836.838-1.291 2.219-1.291 4.47v5.582c0 .998.09 1.825.262 2.51l3.779-2.538c1.008-.676 2.44-.608 3.363.184l.006.006.303.267c.445.379 1.2.378 1.643-.003l3.87-3.32v-.001c1.007-.865 2.594-.864 3.6 0l.278.239V9.459c0-2.251-.454-3.632-1.292-4.47-.837-.836-2.218-1.291-4.47-1.291H9.46c-2.252 0-3.633.455-4.47 1.292Zm15.813 9.373-1.255-1.078c-.444-.382-1.2-.382-1.646 0l-3.87 3.321c-1.006.865-2.593.865-3.6 0l-.006-.006-.304-.266c-.399-.34-1.085-.383-1.546-.074l-4.027 2.703a3.3 3.3 0 0 0 .442.548c.837.837 2.218 1.292 4.47 1.292h5.58c2.252 0 3.633-.455 4.47-1.292.837-.837 1.292-2.218 1.292-4.47v-.678ZM9.46 7.419a1.11 1.11 0 1 0 0 2.22 1.11 1.11 0 0 0 0-2.22Zm-2.61 1.11a2.61 2.61 0 1 1 5.22 0 2.61 2.61 0 0 1-5.22 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMedia;
